var render = function render(){var _vm=this,_c=_vm._self._c;return _c('canvas',{ref:"canvas",on:{"mousedown":_vm.startDrawing,"mousemove":_vm.draw,"mouseup":_vm.stopDrawing,"mouseleave":_vm.stopDrawing,"contextmenu":function($event){$event.preventDefault();return _vm.undo.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }